<template>
    <div class="row">
        <div class="cell align-center"><b>{{ content }}</b></div>
    </div>
</template>

<script>

const defaultText = 'Nothing to show yet';
const defaultFilteredText = 'No results found';

export default {

    props: {
        text: {
            type: String,
            default: defaultText,
        },

        isFiltered: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        content() {
            if (this.isFiltered && this.text === defaultText) {
                return defaultFilteredText;
            }

            return this.text;
        }
    }
}

</script>



// WEBPACK FOOTER //
// resources/js/components/elements/NothingHere.vue